import { GrowthBook } from '@growthbook/growthbook-react';
import { DEFAULT_GROWTHBOOK_FEATURES } from '../growthbook-constants';
const growthbook = new GrowthBook({
  apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_HOST,
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_SECRET,
  enableDevMode: true
});
const host = `${process.env.NEXT_PUBLIC_GROWTHBOOK_HOST}`;
const secret = `${process.env.NEXT_PUBLIC_GROWTHBOOK_SECRET}`;

const loadFeatures = async () => {
  await growthbook.loadFeatures();
};

const getFeatureFlagValue = (key, defaultValue) => {
  if (typeof defaultValue === 'boolean') {
    // Use getFeatureValue with default to ensure default is used when feature doesn't exist
    return growthbook.getFeatureValue(key, defaultValue) ?? defaultValue;
  } else {
    return growthbook.getFeatureValue(key, defaultValue);
  }
};

const fetchAllFeatureFlags = async () => {
  try {
    await loadFeatures();
  } catch (e) {
    // If loading features fails, return defaults
    console.warn('Failed to load GrowthBook features, using defaults:', e);
  }
  
  const featureKeys = DEFAULT_GROWTHBOOK_FEATURES;

  const featureValues = {};
  Object.entries(featureKeys).forEach(([key, defaultValue]) => {
    const value = getFeatureFlagValue(key, defaultValue);
    // Ensure we always use the default if value is null/undefined
    featureValues[key] = value ?? defaultValue;
  });
  return featureValues;
};

export { fetchAllFeatureFlags, growthbook, loadFeatures };
